import { DocumentTitle } from "./DocumentTitle";
export default DocumentTitle;
export * from "./DocumentTitle";
